import emailSpellChecker from '@zootools/email-spell-checker';

/**
 * Returns a corrected email address if the input looks like it has a common
 * domain typo (e.g. "gmial.com" -> "gmail.com"), otherwise null. Powered by
 * @zootools/email-spell-checker (the maintained mailcheck successor). We only
 * ever suggest — never auto-correct — so the caller applies it on click.
 *
 * Shared by the React registration form and the vanilla "find my registration"
 * lookup page so both surfaces catch the same typos.
 */
export function getEmailSuggestion(email: string): string | null {
  const trimmed = email.trim();
  if (!trimmed || !trimmed.includes('@')) return null;
  const suggestion = emailSpellChecker.run({ email: trimmed });
  if (!suggestion || suggestion.full.toLowerCase() === trimmed.toLowerCase()) return null;
  return suggestion.full;
}

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Lightweight format check for on-blur validation (server still validates). */
export function isValidEmailFormat(email: string): boolean {
  return EMAIL_RE.test(email.trim());
}
